import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Tyre Replacement Reason'}
      url={'tyre-replacement-reason'}
      queryKey="tyre-replacement-reason"
      title={'Tyre Replacement Reason'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
